import { Role } from "../../../Helpers/AuthorizationDataProvider";

export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface Props {
	conference?: {date: string, id: string, name: string}
  i18nCountries: any
  id: string
  introduction?: string
	formatDate: (date: string) => void
	mentoringScopes: string[]
	reviews?: JSX.Element
	role: Role
	showReviews: boolean
}

export type HookProps = Omit<Props, "i18nCountries" | "introduction" | "formatDate" | "role">

export interface Education {
  description?: string
  educationId?:string
  endDate?: string
  institution: string
  location: string
  obtainedDegree: string
  startDate: string
}

export interface WorkExperience {
  [key: string]: any
  description?: string
  currentPosition: string
  endDate?: string | any
  institution: string
  location: string
  startDate: string | any
  workExperienceId?:string
}
